module.exports = __webpack_public_path__ + "media/images/icons/croissant-9a713533f2bd95bf7f8f9dacc9f05289.svg";